import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import './style.css';
import { eventStream } from './ws/eventStream';
import { useAuthStore } from './stores/auth';

const app = createApp(App);
app.use(createPinia());
app.use(router);

// WS-Stream startet, sobald ein Token da ist (auch nach Page-Reload via
// localStorage-Restore). Der Auth-Store ist nach createPinia() verfügbar.
const auth = useAuthStore();
if (auth.isAuthenticated) {
  eventStream.start();
}

// Phase 18: bei Logout schließen wir auch die WebSocket-Verbindung,
// damit kein Push-Channel mit gestohlenem Token weiterläuft.
auth.onLogout(() => {
  eventStream.stop();
});

app.mount('#app');
